<template>
    <v-dialog
        v-model="value"
        dense
        prominent
        class="ma-0 py-4"
        color="primary"
        type="warning"
        elevation="2"
        max-width="500"
        persistent
    >
        <v-card>
            <v-card-title class="primary white--text">{{
                titulo
            }}</v-card-title>
            <v-card-text class="mt-6">
                <slot></slot>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: { type: Boolean, required: true },
        titulo: { type: String, required: false },
    },
};
</script>
